import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import UsagePerUser from './UsagePerUserContainer';
import Dashboard from './DashboardContainer';
import styles from './UsageContainer.module.less';

const Usage = () => {
  return (
    <div>
      <div className={styles.header}>Usage analytics</div>
      <Switch>
        <Route path={['/per-user', '/usage/per-user', '/accounts/usage/per-user']} component={UsagePerUser} />
        <Route path={['/dashboard', '/usage/dashboard', '/accounts/usage/dashboard']} component={Dashboard} />
        <Redirect path={['/usage', '/accounts/usage']} to="per-user/" />
      </Switch>
    </div>
  );
};

export default Usage;
